import { render } from "./warehouse.svg?vue&type=template&id=2d3096e2"
const script = {}
script.render = render

export default script